import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as InfoCircle } from 'assets/images/info-circle.svg';

interface RatesProps {
  $active: boolean;
}
export const Rates: any = styled.div``;

Rates.Header = styled.div`
  & h3 {
    margin: 0 0 5px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${ColorPalette.HEX.PineTree};
    margin: 0 0 5px;
  }
  & p {
    font-size: 12px;
    color: ${ColorPalette.HEX.DimGray2};
    letter-spacing: 0;
    margin: 0 0 16px;
  }
`;

export const Card: any = styled.div`
  padding: 16px;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  background-color: ${ColorPalette.HEX.White};
  margin: 24px 0;
`;

Card.Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
`;

Card.Tag = styled.div``;

Card.Subtitle = styled.div`
  font-size: 12px;
  line-height: 1.4em;
`;

Card.Header = styled.div`
  position: relative;
  cursor: pointer;
`;

Card.Title = styled.h1`
  padding: 0 30px 0 0;
  color: ${ColorPalette.HEX.PineTree};
  font-weight: 600;
  font-size: 14px;
  line-height: 1em;
`;

Card.Icon = styled.span`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .icons {
    transition: all 0.3s linear;
    font-size: 24px;
    color: ${ColorPalette.HEX.PineTree};
  }
`;

Card.Body = styled.div<RatesProps>`
  transition: all 0.3s linear;
  overflow: hidden;
  height: ${({ $active }) => ($active ? 'auto' : 'p')};
`;

Card.Rates = styled.div`
  padding-top: 4px;
  margin-top: 10px;
  border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
`;

export const Rate: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 7px 0;
  line-height: 18px;
  &.total-paynow,
  &.agency {
    border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
    margin-top: 14px;
    padding-top: 14px;
  }
  &.total,
  &.total-pay {
    border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
    margin-top: 14px;
    padding-top: 14px;
    text-align: right;
  }
  &.agency {
    border-top: none;
    margin-top: 0;
    padding-top: 5px;
  }
`;
Rate.Label = styled.div`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  &.total-paynow,
  &.agency {
    color: ${ColorPalette.HEX.PineTree};
    font-size: 14px;
    font-weight: 600;
  }
  &.total,
  &.total-pay {
    color: ${ColorPalette.HEX.PineTree};
    font-size: 16px;
    font-weight: 600;
  }
  &.fees {
    color: ${({ theme }) => theme.primaryBackgroundColor};
  }
  &.agency {
    color: ${ColorPalette.HEX.AmberSAEECE};
  }
`;
Rate.Value = styled.div`
  color: ${ColorPalette.HEX.PineTree};
  font-size: 14px;
  &.total-paynow,
  &.agency {
    color: ${ColorPalette.HEX.PineTree};
    font-size: 14px;
    font-weight: 600;
  }
  &.total,
  &.total-pay {
    color: ${ColorPalette.HEX.PineTree};
    font-size: 16px;
    font-weight: 600;
  }
  &.agency {
    color: ${ColorPalette.HEX.AmberSAEECE};
  }
`;

export const InfoCircleIcon = styled(InfoCircle)`
  width: 12px;
  height: 12px;
  margin: 0 0.3em;
  color: ${ColorPalette.HEX.AmberSAEECE};
  position: relative;
  top: 1px;
`;
